import { render, staticRenderFns } from "./badbehaviorList.vue?vue&type=template&id=c91a0af0&scoped=true"
import script from "./badbehaviorList.vue?vue&type=script&lang=js"
export * from "./badbehaviorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c91a0af0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c91a0af0')) {
      api.createRecord('c91a0af0', component.options)
    } else {
      api.reload('c91a0af0', component.options)
    }
    module.hot.accept("./badbehaviorList.vue?vue&type=template&id=c91a0af0&scoped=true", function () {
      api.rerender('c91a0af0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/credit/report/pdfDataInfo/mainRewardInfo/badbehaviorList.vue"
export default component.exports